/**
 * Script mixin
 *
 * Добавляет логику для работы со скриптами
 *
 */

export default {
  staticData: () => ({
    isScriptAborted: false,
    scriptCallBack: null,
    scriptTimeout: null,
  }),
  created() {
    this.initScriptActions();
  },
  methods: {
    initScriptActions() {
      const robotActions = [
        this.$robot.scriptsService.onScriptEnd(this.onScriptEnd),
      ];
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
        this.clearScriptTimeout();
      });
    },
    onScriptEnd() {
      if (this.isScriptAborted) {
        this.clearScriptTimeout();
        this.runScriptCallBack();
      } else {
        this?.onScriptFinished();
      }
    },
    runScript(cb) {
      this.scriptCallBack = cb;
      this.isScriptAborted = true;
      this.scriptTimeout = window.setTimeout(this.runScriptCallBack, 1000);
      this.stopScript();
    },
    runScriptCallBack() {
      this.isScriptAborted = false;
      this?.scriptCallBack();
    },
    stopScript() {
      this.$robot.scriptsService.stopScript();
    },
    clearScriptTimeout() {
      window.clearTimeout(this.scriptTimeout);
    },
  },
};
